import { render, staticRenderFns } from "./SystemInfoNew.vue?vue&type=template&id=4ff52b06&scoped=true"
import script from "./SystemInfoNew.vue?vue&type=script&lang=js"
export * from "./SystemInfoNew.vue?vue&type=script&lang=js"
import style0 from "./SystemInfoNew.vue?vue&type=style&index=0&id=4ff52b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff52b06",
  null
  
)

export default component.exports